import {
  type ReferentialEnum,
  referentialEnumToReferentialCodeList,
} from "@pharmupp/p3-front-commons"

export const orderDeliveryServicesConf = {
  DRIVE: { label: "Drive" },
  CLICK_AND_COLLECT: { label: "Click & Collect" },
  LOCKERS: { label: "Lockers" },
} as const satisfies ReferentialEnum

export type orderDeliveryServiceNames = keyof typeof orderDeliveryServicesConf

export const orderDeliveryServicesReferential = referentialEnumToReferentialCodeList(
  orderDeliveryServicesConf,
)
